<dv-button
  [isSelectedStateActive]="
    !!historicalPositionService.selectedHistoricalDateTime()
  "
  [selected]="isHistoricalPositionActive()"
  (click)="toggleHistoricalPosition()"
  icon="time_history"
  [tooltip]="
    (!!historicalPositionService.selectedHistoricalDateTime()
      ? 'FleetMap.TurnOnLiveMode'
      : 'FleetMap.SelectHistoricalPosition'
    ) | translate
  "></dv-button>
